import { useTraduccion } from '@tallerya/i18n';
import { IconoChevronAbajo, IconoTaller, Menu, type ElementoMenu } from '@tallerya/ui';
import { useTaller } from './ProveedorTaller';

/**
 * El selector de taller del app bar (#205), hermano del de sucursal: el mismo
 * botón, con el ícono del taller y su nombre, que abre un `Menu` con los talleres
 * como opciones excluyentes.
 *
 * - **Sin taller** —sin sesión— no dibuja nada.
 * - **Con uno solo** es texto, sin chevron ni menú, como la sucursal. Se muestra
 *   igual porque es lo único en pantalla que dice de qué taller es la sesión, y
 *   en una computadora compartida importa. Antes lo decía el usuario
 *   (`taller-lopez.emp-0001`); desde #205 el usuario es un correo.
 * - **Con varios**, cada opción lleva el código del taller en gris, al final del
 *   renglón como el «Principal» de la sucursal: es lo que distingue a dos
 *   talleres que se llaman igual (decidido en #205).
 */
export function SelectorTaller() {
  const { t } = useTraduccion();
  const { talleres, actual, elegir } = useTaller();

  if (!actual) return null;

  const etiqueta = t('admin.taller.actual', { nombre: actual.name });

  if (talleres.length === 1) {
    return (
      // Un `span` no anuncia su `aria-label`, así que el texto para el lector
      // va aparte y el nombre visible —que en celular se esconde— se le oculta.
      <span className="selector-sucursal" title={etiqueta}>
        <IconoTaller />
        <span className="selector-sucursal__nombre" aria-hidden="true">
          {actual.name}
        </span>
        <span className="solo-lectores">{etiqueta}</span>
      </span>
    );
  }

  const elementos: ElementoMenu[] = [
    { tipo: 'grupo', etiqueta: t('admin.taller.grupo') },
    ...talleres.map((taller) => ({
      etiqueta: taller.name,
      marcada: taller.id === actual.id,
      detalle: taller.code,
      onSeleccionar: () => elegir(taller.id),
    })),
  ];

  return (
    <Menu
      ancho={260}
      elementos={elementos}
      disparador={({ alternar, atributos }) => (
        <button
          type="button"
          className="selector-sucursal selector-sucursal--boton"
          aria-label={etiqueta}
          onClick={alternar}
          {...atributos}
        >
          <IconoTaller />
          <span className="selector-sucursal__nombre">{actual.name}</span>
          <IconoChevronAbajo />
        </button>
      )}
    />
  );
}
